/* eslint-disable no-empty */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useMemo, useRef, useState } from "react";
import {
  formatNumberToFixed,
  getInputFieldProps,
  parseNumericValue,
  safeToString,
} from "../../../utils/common";
import {
  PAY_AND_BENEFITS_API,
  PAY_AND_BENEFITS_CONST,
  PAY_AND_BENEFITS_INITIAL_STATE,
  SALARY_KNOWN_BASIC,
  SALARY_KNOWN_CTC,
  SALARY_TYPE_SALARY,
} from "./pay-benefit-const";

import { useNavigate, useParams } from "react-router-dom";
import { useAuthContext } from "../../../context/authContext";
import { useToast } from "../../../context/toast-context";
import useAPIHandler from "../../../hook/use-api-handler";
import { logger } from "../../../utils/logger";
import {
  ALLOWANCE_INITIAL_STATE,
  ALLOWANCE_INPUT_FIELDS,
} from "../../organization/allowance/allowance-constant";
import { allowanceSchema } from "../../organization/allowance/allowance-validation";
import useBenifitService from "../../organization/benefit/use-benefit-service";
import {
  calculatePerformance,
  calculationAllowanceAmount,
  calculationAllowanceInfo,
} from "./pay-benefit-utils";
export const EmployeePayandBenefits = () => {
  const [salaryBreakdown, setSalaryBreakdown] = useState(false);
  const { showToastMessage } = useToast();
  const {orgDetails}=useAuthContext()
  const {benefitViewData}=useBenifitService()
  const [createFormUpdateLoading, setCreateFormUpdateLoading] = useState(false);
  const hasRun = useRef(false);
  const [errors, setErrors] = useState({});
  const [otherAllowanceCalculation, setOtherAllowanceCalculation] = useState({
    allowanceName: "",
    allowanceValue: 0,
    allowanceType: "fixed",
    noWorkNoPay: false,
    addToGross: true,
    isEsiWages: false,
    isEpfWages: false,
  });
  const navigate = useNavigate();
  const [allowance, setAllowance] = useState(ALLOWANCE_INITIAL_STATE);
  const [employeeEPFInfo, setEmployeeEPFInfo] = useState({});
  const [empbenId, setEmpbenId] = useState(null);
  const [allowancedialogOpen, setsetAllowancedialogOpen] = useState(false);
  const [employeePayBenefits, setEmployeePayBenefits] = useState(
    structuredClone(PAY_AND_BENEFITS_INITIAL_STATE)
  );
  const [targetpath, setTargetpath] = useState(null);
  const [allowanceList, setallowanceList] = useState([]);
  const [totalAllowance, setTotalAllow] = useState([]);
  const [addedepf13, setAddedepf13] = useState(null);
  const [addedEsi, setAddedEsi] = useState(null);

  const { fetchData } = useAPIHandler();

  const { id: employeeId } = useParams();

  async function getemployeeStatutoryFn() {
    try {
      const employeeStatutoryData = await fetchData({
        url: `/employee/statutory/${employeeId}`,
      });
      const organizationStatutoryData = await fetchData({
        url: `/organization-statutory/organization-epf`,
      });
      const organizationEsicData = await fetchData({
        url: `/organization-statutory/esi`,
      });

      setEmployeeEPFInfo({
        employeeStatutoryData: { ...employeeStatutoryData?.data },
        organizationStatutoryData: { ...organizationStatutoryData?.data },
        organizationEsicData: { ...organizationEsicData?.data },
      });
    } catch (error) {}
  }

  useEffect(() => {
    getemployeeStatutoryFn();
  }, []);

  const handleChangeFunction = (e, name, id) => {
    let value = e;

    const updatedObj = {};

    if (e && e.target) {
      value = e.target.value;
    }

    if (
      PAY_AND_BENEFITS_CONST[name] &&
      PAY_AND_BENEFITS_CONST[name].customOptions &&
      PAY_AND_BENEFITS_CONST[name].customOptions?.formatValueFn
    ) {
      value = PAY_AND_BENEFITS_CONST[name].customOptions?.formatValueFn(
        value,
        employeePayBenefits
      );
    }

    if (name === "salary_type" && e === "wages") {
      setEmployeePayBenefits({
        ...employeePayBenefits,
        basic_percentage: null,
        salary_known: null,
        basic_salary: null,
        gross_salary: null,
        ctc_salary: null,
      });
      const updatedAllowances = allowanceList.map((allowance) => ({
        ...allowance,
        isChecked: false,
      }));
      setallowanceList(updatedAllowances);
    }
    if (name === "salary_type" && e === "salary") {
      setEmployeePayBenefits({
        ...employeePayBenefits,
        basic_percentage: 60,
        salary_known: "ctc_salary",
        basic_salary: null,
        gross_salary: null,
        wages_rate: null,
        wages_day: null,
        ctc_salary: null,
      });
      const updatedAllowances = allowanceList.map((allowance) => ({
        ...allowance,
        isChecked: false,
      }));
      setallowanceList(updatedAllowances);
    }

    if (employeePayBenefits.salary_type === SALARY_TYPE_SALARY) {
      if (name === "salary_known") {
        if (
          employeePayBenefits.salary_known === SALARY_KNOWN_CTC &&
          value === SALARY_KNOWN_BASIC
        ) {
          updatedObj.basic_salary = Math.round(
            parseNumericValue(employeePayBenefits.basic_salary)
          );

          updatedObj.basicSalaryPercentageAmount = updatedObj.basic_salary;

          updatedObj.ctc_salary =
            updatedObj.basicSalaryPercentageAmount +
            calculationAllowanceAmount({
              basicSalaray: updatedObj.basic_salary,
              allowanceList: allowanceList,
            });
        }
        if (
          employeePayBenefits.salary_known === SALARY_KNOWN_BASIC &&
          value === SALARY_KNOWN_CTC
        ) {
          updatedObj.basic_percentage = 60;
          updatedObj.basic_salary = Math.round(
            parseNumericValue(employeePayBenefits.basic_salary)
          );
          updatedObj.basicSalaryPercentageAmount = formatNumberToFixed(
            parseNumericValue(updatedObj.basic_salary * (160 / 100))
          );

          updatedObj.ctc_salary =
            updatedObj.basicSalaryPercentageAmount +
            calculationAllowanceAmount({
              basicSalaray: updatedObj.basic_salary,
              allowanceList: allowanceList,
            });
        }
      }

      if (name === "ctc_salary") {
        updatedObj.basic_salary = formatNumberToFixed(
          (value * parseNumericValue(employeePayBenefits.basic_percentage)) /
            100
        );
      }

      if (name === "basic_percentage") {
        updatedObj.basic_salary = formatNumberToFixed(
          (employeePayBenefits.ctc_salary * parseNumericValue(value)) / 100
        );
      }

      if (
        employeePayBenefits.salary_known === SALARY_KNOWN_BASIC &&
        name === "basic_salary"
      ) {
        updatedObj.basic_salary = formatNumberToFixed(parseNumericValue(value));
        updatedObj.ctc_salary =
          updatedObj.basic_salary +
          calculationAllowanceAmount({
            basicSalaray: updatedObj.basic_salary,
            allowanceList: allowanceList,
          });
      }

      if (name === "employee_weekly_holiday") {
        setEmployeePayBenefits((prevState) => ({
          ...prevState,
          employee_weekly_holiday: {
            ...prevState.employee_weekly_holiday,
            [id]: value,
          },
        }));
      } else {
        setEmployeePayBenefits((prevState) => ({
          ...prevState,
          [name]: value,
          ...updatedObj,
        }));
      }
    } else {
      setEmployeePayBenefits((prevState) => ({
        ...prevState,
        [name]: value,
        ...updatedObj,
      }));
    }
  };

  useEffect(() => {
    if (employeePayBenefits?.wages_rate && employeePayBenefits?.wages_day) {
      setEmployeePayBenefits({
        ...employeePayBenefits,
        gross_salary:
          Number(employeePayBenefits?.wages_rate) *
          Number(employeePayBenefits?.wages_day),
        basic_salary:
          Number(employeePayBenefits?.wages_rate) *
          Number(employeePayBenefits?.wages_day),
        ctc_salary:
          Number(employeePayBenefits?.wages_rate) *
          Number(employeePayBenefits?.wages_day),
      });
    }
  }, [employeePayBenefits?.wages_rate, employeePayBenefits?.wages_day]);

  useEffect(() => {
    setallowanceList([]);
    fetchData({
      url: `/employee/employee-benefit-allowance/${employeeId}`,
    }).then((res) => {
      setTotalAllow(res?.data);
      setallowanceList(
        res?.data?.filter(
          (it) => it?.is_default !== true && { ...it, isChecked: false }
        )
      );
      if (res?.data?.length > 0) {
      
        res?.data?.map((it) => {
          if (it?.is_default) {
            setOtherAllowanceCalculation({
              ...otherAllowanceCalculation,
              ...it,
            });
          }
        });
      }
    });
  }, []);

  function mergeArrays(arrayOne, arrayTwo) {
    // Create a map for quick lookup of arrayTwo by allowanceId
    const arrayTwoMap = new Map(
      arrayTwo.map((item) => [item.allowanceId, item])
    );

    // Iterate through arrayOne and replace or keep objects dynamically
    const mergedArray = arrayOne.map((item) => {
      // Check if the current allowanceId exists in arrayTwo
      if (arrayTwoMap.has(item.allowanceId)) {
        // Replace the object with the one from arrayTwo and add isChecked: true
        return {
          ...item,
          ...arrayTwoMap.get(item.allowanceId),
          isChecked: true,
        };
      }
      // Add isChecked: false for objects without a match
      return { ...item, isChecked: false };
    });

    return mergedArray;
  }

  function getEmployeeAllowence() {
    const payload = {
      url: `/employee/employee-benefit/${employeeId}`,
      METHOD: "GET",
    };
    try {
      fetchData(payload)
        .then((res) => {
          setEmpbenId(res?.data?.employee_benefit_id);
          const resexisting = res?.data?.employee_allowences;
          const newArray = mergeArrays(totalAllowance, resexisting);
          const otheallow = newArray?.find((ele) => ele?.is_default === true);
          setOtherAllowanceCalculation(otheallow);
          const remainallow = newArray?.filter((ele) => !ele?.is_default);
          setallowanceList(remainallow);
          setEmployeePayBenefits({
            employee_weekly_holiday: res?.data?.employee_weekly_holidays,
            salary_type: res?.data?.salaryType,
            salary_known: res?.data?.salaryKnown,
            basic_salary: res?.data?.basicSalary,
            ctc_salary: res?.data?.ctcSalary,
            basic_percentage: res?.data?.basicPercentage,
            wages_type: res?.data?.wagesType,
            wages_rate: res?.data?.wagesRate,
            wages_payment_mode: res?.data?.wagesPaymentMode,
            wages_day: res?.data?.wagesDay,
            payment_mode: res?.data?.paymentMode,
            ot_rate: res?.data?.otRate,
            labour_welfare_fund: res?.data?.labourWelfareFund,
          });
        })
        .catch((err) => {
          logger.log(err);
        });
    } catch (error) {
      logger.log(error);
    }
  }

  useEffect(() => {
    if (allowanceList?.length > 0||otherAllowanceCalculation?.is_default) {
      if (!hasRun.current) {
        getEmployeeAllowence();
        hasRun.current = true;
      }
    }
  }, [allowanceList]);



  const onSubmitAllowanceHandler = async () => {
    const isAdjustAllowance = allowance?.customId === "adjustAllowanceId";

    if (isAdjustAllowance) {
      setOtherAllowanceCalculation(allowance);
      setsetAllowancedialogOpen(false);

      return;
    }

    const {
      allowanceName,

      allowanceType,
      allowanceValue,
      noWorkNoPay,
      addToGross,
      isEsiWages,
      isEpfWages,
      status,
    } = allowance;

    const { error } = allowanceSchema.validate(
      {
        allowanceName,

        allowanceType,
        allowanceValue,
        noWorkNoPay,
        addToGross,
        isEsiWages,
        isEpfWages,
        status,
      },
      {
        abortEarly: false,
        context: { allowanceType },
      }
    );

    if (error && error?.details?.length > 0) {
      const validationErrors = error.details.reduce((acc, err) => {
        const pathname = err.path.join(".");
        acc[pathname] = err.message;
        return acc;
      }, {});
      setErrors(validationErrors);
    } else {
      setallowanceList((prev) =>
        prev.map((it) =>
          it?.allowanceId === allowance?.allowanceId ? allowance : it
        )
      );

      setsetAllowancedialogOpen(false);
    }
  };

  const handleAllownceChangeFunction = (e, name) => {
    let value = e;

    if (e && e.target) {
      value = e.target.value;
    }

    if (
      ALLOWANCE_INPUT_FIELDS[name].customOptions &&
      ALLOWANCE_INPUT_FIELDS[name].customOptions?.formatValueFn
    ) {
      value = ALLOWANCE_INPUT_FIELDS[name].customOptions?.formatValueFn(
        value,
        allowance
      );
    }

    setAllowance((prevUser) => ({
      ...prevUser,
      [name]: value,
    }));

    const fieldSchema = allowanceSchema.extract(name);
    const { error } = fieldSchema.validate(value, {
      context: { allowanceType: allowance.allowanceType },
    });

    if (!error) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: undefined,
      }));
    }
  };





  const handleCheckAllowance = (allowanceInfo) => {
    if (employeePayBenefits?.salary_type === "wages") {
      let ctcValue;
      setallowanceList((prev) =>
        prev.map((item) => {
          return item.allowanceId === allowanceInfo?.allowanceId
            ? { ...item, isChecked: !item.isChecked }
            : item;
        })
      );
      const amountValue =
        allowanceInfo.allowanceType === "percentage"
          ? parseNumericValue(employeePayBenefits.basic_salary) *
            parseNumericValue(allowanceInfo.allowanceValue / 100)
          : parseNumericValue(allowanceInfo.allowanceValue);
      if (!allowanceInfo?.isChecked) {
        ctcValue = formatNumberToFixed(
          parseNumericValue(employeePayBenefits.ctc_salary) +
            Number(amountValue)
        );
      } else {
        ctcValue = formatNumberToFixed(
          parseNumericValue(employeePayBenefits.ctc_salary) -
            Number(amountValue)
        );
      }
      setEmployeePayBenefits((prevUser) => ({
        ...prevUser,
        ctc_salary: ctcValue,
        gross_salary: ctcValue,
      }));
    } else {
      setallowanceList((prev) =>
        prev.map((item) => {
          return item.allowanceId === allowanceInfo?.allowanceId
            ? { ...item, isChecked: !item.isChecked }
            : item;
        })
      );

      const isBasicKnown =
        employeePayBenefits.salary_known === SALARY_KNOWN_BASIC;

      if (isBasicKnown) {
        const amountValue =
          allowanceInfo.allowanceType === "percentage"
            ? parseNumericValue(employeePayBenefits.basic_salary) *
              parseNumericValue(allowanceInfo.allowanceValue / 100)
            : parseNumericValue(allowanceInfo.allowanceValue);

        let ctcValue;
        if (!allowanceInfo?.isChecked) {
          ctcValue = formatNumberToFixed(
            parseNumericValue(employeePayBenefits.ctc_salary) + amountValue
          );
        } else {
          ctcValue = formatNumberToFixed(
            parseNumericValue(employeePayBenefits.ctc_salary) - amountValue
          );
        }
        setEmployeePayBenefits((prevUser) => ({
          ...prevUser,
          ctc_salary: ctcValue,
        }));
      }
    }
  };

  const getInputFieldPropsFn = (fieldName = "") => {
    // eslint-disable-next-line no-unused-vars
    const { customOptions = {}, ...restProps } =
      PAY_AND_BENEFITS_CONST[fieldName] || {};

    const error = safeToString(errors[fieldName]);
    const props = {
      ...restProps,
      ...getInputFieldProps({
        name: fieldName,
        stateValues: employeePayBenefits,
        type: restProps.type || "text",
        error,
        // handleBlurFn,
        handleChangeFunction,
      }),
    };

    return props;
  };
  const getAllowanceInputFieldPropsFn = (fieldName = "") => {
    // eslint-disable-next-line no-unused-vars
    const { customOptions = {}, ...restProps } =
      ALLOWANCE_INPUT_FIELDS[fieldName] || {};

    const error = safeToString(errors[fieldName]);
    const props = {
      ...restProps,
      ...getInputFieldProps({
        name: fieldName,
        stateValues: allowance,
        type: restProps.type || "text",
        error,
        // handleBlurFn,
        handleChangeFunction: handleAllownceChangeFunction,
      }),
    };

    return props;
  };

const [useractionbutton,setUseractionbutton]=useState(false)
  const SalaryBreakdownOpen = () => setSalaryBreakdown(true);

  const hasEmployerContibutionIncludeInCTC = (
    employeeEPFInfo?.organizationStatutoryData?.epfOrganizationMaster || []
  )?.includes(1);

  const contribution15K =
    employeeEPFInfo?.employeeStatutoryData?.employee_contribution ===
    "restrict_contribution";

  const CTC = employeePayBenefits?.ctc_salary;
  const basicSalary = employeePayBenefits?.basic_salary;

  const allowanceInfo = useMemo(
    () =>
      calculationAllowanceInfo({ allowanceList, basicSalaray: basicSalary }),
    [allowanceList, basicSalary]
  );

  const adjustAllowanceAmount = formatNumberToFixed(
    CTC - allowanceInfo?.checkedAllowancesSum - basicSalary
  );

  const isPerformanceEPFCoverd = otherAllowanceCalculation?.isEpfWages;
  const basicAndCheckedAllowanceSum = allowanceInfo?.checkedAllowancesSum + basicSalary;
  const ctcAmount = allowanceInfo?.checkedAllowancesSum + basicSalary;
  const grossAmount = allowanceInfo?.grossIncludedCheckedAllowanceSum + basicSalary;
  const epfCoveredWages = allowanceInfo?.epfCoveredAllowancesSum + basicSalary;
  const esiCoveredWages = allowanceInfo?.esiCoveredAllowancesSum + basicSalary;
  const epfEsiEligibalePercentage = employeeEPFInfo?.organizationStatutoryData?.epfOrganizationStatus
  const epf_availability  = employeeEPFInfo?.employeeStatutoryData?.epf_availability;
  const esi_availability  = employeeEPFInfo?.employeeStatutoryData?.esi_availability;
  
  const isIncludeAdminCharge = employeeEPFInfo?.organizationStatutoryData?.epfOrganizationMaster?.includes(2);
  const isIncludeESICharge = employeeEPFInfo?.organizationEsicData?.is_including_employee_ctc;
  // logger.log(esiCoveredWages+"ppsesi");

  const performanceAmount = useMemo(
    () =>
      calculatePerformance({
        hasEmployerContibutionIncludeInCTC,
        CTC,
        contribution15K,
        basicAndCheckedAllowanceSum,
        grossAmount,
        isPerformanceEPFCoverd,
        epfCoveredWages,
        esiCoveredWages,
        epfEsiEligibalePercentage,
        epf_availability,
        esi_availability,
        isIncludeAdminCharge,
        isIncludeESICharge,
        ctcAmount
      }),
    [
      hasEmployerContibutionIncludeInCTC,
      contribution15K,
      isPerformanceEPFCoverd,
      epfCoveredWages,
      esiCoveredWages,
      basicAndCheckedAllowanceSum,
      grossAmount,
      CTC,
      ctcAmount,
    ]
  );

  async function handleSubmitPayBenefitFn() {
    try {
      const basicAndCheckedAllowanceSum = employeePayBenefits?.basic_salary + allowanceInfo?.checkedAllowancesSum;
      let grossAmount = employeePayBenefits?.basic_salary +  allowanceInfo?.grossIncludedCheckedAllowanceSum;
      let ctcAmount = employeePayBenefits?.basic_salary +  allowanceInfo?.checkedAllowancesSum;
       
      const config = PAY_AND_BENEFITS_API.PAY_AND_BENEFITS_CREATE;

      let finalAllowanseList = [...allowanceList];

      if (
        employeePayBenefits.salary_type === SALARY_TYPE_SALARY &&
        employeePayBenefits.salary_known !== SALARY_KNOWN_BASIC
      ) {
        const performanceCalAmount = calculatePerformance({
          hasEmployerContibutionIncludeInCTC,
          CTC,
          contribution15K,
          basicAndCheckedAllowanceSum,
          isPerformanceEPFCoverd,
          epfCoveredWages,
          epf_availability,
          esiCoveredWages,
          esi_availability,
          isIncludeAdminCharge,
          isIncludeESICharge,
          grossAmount,
        });

        if (performanceCalAmount > 0) {
          finalAllowanseList.push({
            ...otherAllowanceCalculation,
            allowanceValue: performanceCalAmount,
            isChecked: true,
          });
        }
        if (employeePayBenefits?.salary_known === SALARY_KNOWN_CTC) {
          grossAmount = grossAmount + performanceCalAmount;
          ctcAmount = basicAndCheckedAllowanceSum + performanceCalAmount;
        }
      }
      grossAmount = formatNumberToFixed(parseNumericValue(grossAmount));
      ctcAmount = formatNumberToFixed(parseNumericValue(ctcAmount));

      finalAllowanseList = finalAllowanseList
        ?.filter((item) => item.isChecked)
        ?.map(
          ({
            allowanceId,
            allowanceName,
            allowanceType,
            allowanceValue,
            noWorkNoPay,
            addToGross,
            isEsiWages,
            isEpfWages,
          }) => ({
            allowance_id: allowanceId,
            allowance_name: allowanceName,
            allowance_type: allowanceType,
            allowance_value: allowanceValue,
            no_work_no_pay: noWorkNoPay,
            add_to_gross:addToGross,
            is_esi_wages: isEsiWages,
            is_epf_wages: isEpfWages,
          })
        );
      delete employeePayBenefits?.employee_weekly_holiday;
      delete employeePayBenefits?.basicSalaryPercentageAmount;
      
      if (employeePayBenefits?.ot_rate === "") {
        employeePayBenefits.ot_rate = null;
      }
      await fetchData({
        ...config,
        url: empbenId
          ? `/employee/employee-benefit/${employeeId}/update/${empbenId}`
          : `/employee/employee-benefit/${employeeId}`,
        data: {
          ...employeePayBenefits,
          basic_percentage:
            employeePayBenefits?.salary_known === "ctc_salary"
              ? employeePayBenefits?.basic_percentage
              : null,
           ctc_salary: (hasEmployerContibutionIncludeInCTC && isIncludeESICharge)
                ? addedepf13 + addedEsi + ctcAmount
                :(!hasEmployerContibutionIncludeInCTC && isIncludeESICharge) 
                  ? addedEsi + ctcAmount 
                  : (hasEmployerContibutionIncludeInCTC && !isIncludeESICharge) 
                    ? addedepf13  + ctcAmount
                    : ctcAmount,

          gross_salary: grossAmount,
          employee_allowance: finalAllowanseList,
          labour_welfare_fund:orgDetails?.
          is_allow_lwf?employeePayBenefits?.labour_welfare_fund:'No'   ,
                
        },
        
      });
     

      showToastMessage({ message: "Pay Benefit Added successfully!" });
      setSalaryBreakdown(false);
      navigate(targetpath);
    } catch (error) {
      if (error?.type === "JoiValidationError") {
        const errorsAll = {};

        error?.errors?.map((item) => {
          const { field, message } = item;
          errorsAll[field] = message;
        });

        showToastMessage({
          message:
            Object.keys(errorsAll).length > 0
              ? "Validation Error!"
              : "Something went wrong!",
          color: "danger",
        });
        setErrors(errorsAll);
      }

      if (error?.type === "GeneralError") {
        showToastMessage({
          message: error.message || "An unknown general error occurred.",
          color: "danger",
        });
      }
      setCreateFormUpdateLoading(false);
      
    }
    
  }

  return {
    getInputFieldPropsFn,
    allowanceList,
    employeePayBenefits,
    allowancedialogOpen,
    setsetAllowancedialogOpen,
    allowance,
    setAllowance,
    handleAllownceChangeFunction,
    onSubmitAllowanceHandler,
    getAllowanceInputFieldPropsFn,
    setallowanceList,
    handleCheckAllowance,
    otherAllowanceCalculation,
    setOtherAllowanceCalculation,
    salaryBreakdown,
    setSalaryBreakdown,
    SalaryBreakdownOpen,
    adjustAllowanceAmount,
    performanceAmount,
    allowanceInfo,
    employeeEPFInfo,
    setEmployeeEPFInfo,
    handleChangeFunction,
    handleSubmitPayBenefitFn,
    createFormUpdateLoading,
    totalAllowance,
    setAddedepf13,
    setAddedEsi,
    targetpath,
    setTargetpath,
    employeeId,
    orgDetails,
    benefitViewData,
    useractionbutton,
    setUseractionbutton
  };
};